import { Box, Typography } from "@mui/material";
import React, { FC, useMemo } from "react";

interface Props {
  selected?: string[];
}

export const SelectValue: FC<Props> = ({ selected }) => {
  const selectedStr = useMemo(() => {
    const str = selected.map((i) => {
      return i === "all" ? "All" : i;
    });
    return str.join(", ");
  }, [selected]);
  return (
    <Box sx={{ overflow: "hidden", textOverflow: "ellipsis", width: "100%" }}>
      <Typography sx={{ mr: "1em", fontSize: "12px" }}>
        {selectedStr}
      </Typography>
    </Box>
  );
};
